import React, { createContext, useContext, useState } from "react";

type OverlayContext = {
  setIsVisible: (state: boolean) => void;
};

export const OverlayContext = createContext<OverlayContext>({
  setIsVisible: (state: boolean) => null,
});

export function DisabledOverlayProvider({
  children,
}: React.HtmlHTMLAttributes<HTMLElement>) {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  return (
    <OverlayContext.Provider value={{ setIsVisible }}>
      {children}
      {isVisible ? (
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100vh",
          }}
        />
      ) : null}
    </OverlayContext.Provider>
  );
}

export const useDisabledOverlay = () =>
  useContext<OverlayContext>(OverlayContext);
